import { Fragment } from "react";


export const menus = [
    {
        id: 1,
        steps: 1,
        render: <Fragment>
            <span class="number">1.</span> Project preferences <i class="fa fa-angle-right"></i>
        </Fragment>
    },
    {
        id: 2,
        steps: 3,
        render: <Fragment>
            <span class="number">2.</span> Specialization and stack <i class="fa fa-angle-right"></i>
        </Fragment>
    },
    {
        id: 3,
        steps: 6,
        render: <Fragment>
            <span class="number">3.</span> Additional info <i class="fa fa-angle-right"></i>
        </Fragment>
    },
    {
        id: 4,
        steps: 8,
        render: <Fragment>
            <span class="number">4.</span> Registration <i class="fa fa-angle-right"></i>
        </Fragment>
    },
];

export const employmentType = [
    {
        id: 1,
        value: "PART_TIME",
        render: <Fragment>
            <figure><img src="images/find-job-icon-1.png" alt="" /></figure>
            <h3>Part-Time <span>20-35 hours/week</span></h3>
        </Fragment>
    },
    {
        id: 2,
        value: "FULL_TIME",
        render: <Fragment>
            <figure><img src="images/find-job-icon-2.png" alt="" /></figure>
            <h3>Full-Time <span>40 hours/week</span></h3>
        </Fragment>
    },
    {
        id: 3,
        value: "None",
        render: <Fragment>
            <figure><img src="images/find-job-icon-3.png" alt="" /></figure>
            <h3>None <span> just checking around</span></h3>
        </Fragment>
    },
]

export const specializationList = [
    {
        id: 1,
        value: 1,
        render: <Fragment>
            <figure><img src="images/sp-icon-1.png" alt="" /></figure>
            <h3><span>Front-end Web</span>Developer</h3>
        </Fragment>
    },
    {
        id: 2,
        value: 2,
        render: <Fragment>
            <figure><img src="images/sp-icon-2.png" alt="" /></figure>
            <h3><span>Back-end Web</span> Developer</h3>
        </Fragment>
    },
    {
        id: 3,
        value: 3,
        render: <Fragment>
            <figure><img src="images/find-job-icon-3.png" alt="" /></figure>
            <h3><span> Full-stack</span> Web Developer</h3>
        </Fragment>
    },
    {
        id: 4,
        value: 4,
        render: <Fragment>
            <figure><img src="images/other-icon-1.png" alt="" /></figure>
            <h3><span>Mobile</span>Developer</h3>
        </Fragment>
    },
    {
        id: 5,
        value: 5,
        render: <Fragment>
            <figure><img src="images/other-icon-2.png" alt="" /></figure>
            <h3><span>AI</span> Engineer</h3>
        </Fragment>
    },
    {
        id: 6,
        value: 6,
        render: <Fragment>
            <figure><img src="images/other-icon-3.png" alt="" /></figure>
            <h3>Choose other</h3>
        </Fragment>
    },
]

export const SENIORITY_CHOICES = [
    {"label": "Junior", "value": "JUNIOR"},
    {"label": "Intermediate", "value": "INTERMEDIATE"},
    {"label": "Senior", "value": "SENIOR"},
 ]

export const defaultExperience = 1
export const experienceOption = [
    {
        label: "0.5 year",
        value: 0.5
    },
    {
        label: "1 year",
        value: 1
    },
    {
        label: "1.5 years",
        value: 1.5
    },
    {
        label: "2 years",
        value: 2
    },
    {
        label: "2.5 years",
        value: 2.5
    },
]

export const interview_option = [
    {
        id: 1,
        value: "BEGINNER",
        render: <Fragment>
            <div className="box-header">
                <img src="images/interview-icon-1.png" alt="" />
                <strong>Ooph, better not</strong>
            </div>
            <p>My English is good enough for written
                communication only</p>
        </Fragment>
    },
    {
        id: 2,
        value: "FLUENT",
        render: <Fragment>
            <div className="box-header">
                <img src="images/interview-icon-2.png" alt="" />
                <strong>Sure, no probem at all</strong>
            </div>
            <p>I can handle both on interview and
                day-to-day work withEnglish-speaking
                teammates</p>
        </Fragment>
    }
]